module.exports = __webpack_public_path__ + "img/Skirt-Front-B1-Da-Fc-Gc-Hc-Ia.8582dd45.png";